<template>
    <div class="deal-viewer">
        <a-tabs>
            <a-tab-pane key="details" tab="Fırsat Detayları">
                <div class="deal-sections">
                    <div class="deal-section">
                        <div class="section-title">Temel Bilgiler</div>
                        <div class="field-group">
                            <div class="field">
                                <label>
                                    <i class="material-icons">sell</i>
                                    Fırsat Adı
                                </label>
                                <div class="value">{{ deal.Deal_Name }}</div>
                            </div>
                            <div class="field">
                                <label>
                                    <i class="material-icons">linear_scale</i>
                                    Aşama
                                </label>
                                <div class="value">{{ deal.Stage }}</div>
                            </div>
                            <div class="field">
                                <label>
                                    <i class="material-icons">person</i>
                                    Sorumlu
                                </label>
                                <div class="value">{{ $_.get(deal, "Owner.name", "") }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="deal-section">
                        <div class="section-title">İletişim Bilgileri</div>
                        <div class="field-group">
                            <div class="field" v-if="deal.Phone">
                                <label>
                                    <i class="material-icons">phone</i>
                                    Telefon
                                </label>
                                <div class="value">{{ maskPhone(deal.Phone) }}</div>
                            </div>
                            <div class="field" v-if="deal.Email">
                                <label>
                                    <i class="material-icons">email</i>
                                    E-posta
                                </label>
                                <div class="value">{{ maskEmail(deal.Email) }}</div>
                            </div>
                            <div class="field" v-if="deal.COUNTRY">
                                <label>
                                    <i class="material-icons">public</i>
                                    Ülke
                                </label>
                                <div class="value">{{ deal.COUNTRY }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="deal-section">
                        <div class="section-title">Detay Bilgiler</div>
                        <div class="field-group">
                            <div class="field">
                                <label>
                                    <i class="material-icons">category</i>
                                    Fırsat Tipi
                                </label>
                                <div class="value">{{ deal.Deal_Type }}</div>
                            </div>
                            <div class="field">
                                <label>
                                    <i class="material-icons">event</i>
                                    Oluşturulma Tarihi
                                </label>
                                <div class="value">{{ formatDate(deal.Created_Time) }}</div>
                            </div>
                            <div class="field">
                                <label>
                                    <i class="material-icons">update</i>
                                    Son Güncelleme
                                </label>
                                <div class="value">{{ formatDate(deal.Modified_Time) }}</div>
                            </div>
                            <div class="field">
                                <label>
                                    <i class="material-icons">tag</i>
                                    Hasta ID
                                </label>
                                <div class="value">{{ deal.HASTA_ID }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </a-tab-pane>

            <a-tab-pane key="notes" tab="Notlar">
                <DealNotes :dealId="deal.id" @connect-zoho="$emit('connect-zoho')" />
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
import Vue from "vue";
import DealNotes from "./DealNotes.vue";

export default Vue.extend({
    name: "DealViewer",
    components: {
        DealNotes,
    },
    props: {
        deal: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatAmount(amount) {
            return new Intl.NumberFormat("tr-TR", {
                style: "currency",
                currency: "TRY",
            }).format(amount || 0);
        },
        formatDate(dateString) {
            if (!dateString) return "";
            return new Date(dateString).toLocaleDateString("tr-TR", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        },
        maskPhone(phone) {
            if (!phone) return "";
            // Telefon numarasından tüm boşlukları ve özel karakterleri temizle
            const cleanPhone = phone.replace(/\D/g, "");

            // Türkiye formatı için (5XX) XXX-XX-XX
            if (cleanPhone.length === 10) {
                const firstPart = cleanPhone.slice(0, 6);
                const maskedPart = cleanPhone.slice(6).replace(/\d/g, "*");
                return `(${cleanPhone.slice(0, 3)}) ${cleanPhone.slice(3, 6)}-${maskedPart}`;
            }

            // Eğer 10 haneli değilse, ilk 6 haneyi göster
            const visibleDigits = cleanPhone.slice(0, 6);
            const maskedDigits = cleanPhone.slice(6).replace(/\d/g, "*");
            return visibleDigits + maskedDigits;
        },
        maskEmail(email) {
            if (!email) return "";
            const [localPart, domain] = email.split("@");
            const maskedLocalPart = localPart.slice(0, 2) + "*".repeat(localPart.length - 2);
            return `${maskedLocalPart}@${domain}`;
        },
    },
});
</script>

<style scoped lang="scss">
.deal-viewer {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .deal-sections {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .deal-section {
        .section-title {
            font-weight: 600;
            font-size: 16px;
            color: #2d3748;
            margin-bottom: 16px;
            padding-bottom: 8px;
            border-bottom: 1px solid #e2e8f0;
        }

        .field-group {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;

            .field {
                label {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 13px;
                    color: #64748b;
                    margin-bottom: 4px;

                    i {
                        font-size: 16px;
                    }
                }

                .value {
                    font-size: 14px;
                    color: #1a202c;
                }
            }
        }
    }
}
</style>
